const de = {
  newsletter: 'Newsletter',
  recipientlists: 'Empfängerlisten',
  recipients: 'Empfänger',
}
export default de;